<template lang="html">
  <div class="index-main">
    <comp-kick></comp-kick>
    <comp-alive></comp-alive>
    <comp-bar v-if="workSpaceLoaderStatus"></comp-bar>
    <comp-space @workspacesList="workSpaceLoader"></comp-space>
    <comp-box></comp-box>
    <comp-lang></comp-lang>
    <comp-down v-if="browser !== 'qt'"></comp-down>
    <comp-downMsg v-if="browser !== 'qt'"></comp-downMsg>
    <comp-menu></comp-menu>
    <comp-animation></comp-animation>
    <div
      class="main-box"
      ondragenter="event.stopPropagation();event.preventDefault();"
      ondragover="event.stopPropagation();event.preventDefault();"
      ondrop="event.stopPropagation();event.preventDefault();"
    >
      <div v-if="workSpaceLoaderStatus" class="view-box" :style="{paddingLeft: paddingLeft}">
        <comp-workspace v-if="workSpaceLoaderStatus"></comp-workspace>
        <!-- <transition name="fade"> -->
          <router-view></router-view>
        <!-- </transition> -->
      </div>
      <comp-ball v-if="workSpaceLoaderStatus"></comp-ball>
      <comp-new v-if="workSpaceLoaderStatus"></comp-new>
      <comp-msg></comp-msg>
      <comp-version></comp-version>
    </div>
    <comp-keep></comp-keep>
  </div>
</template>

<script>
import CompKick from '@/app/components/kick.vue'
import CompKeep from '@/app/components/keepAlive.vue'
import CompBar from '@/components/bar.vue'
import CompMenu from '@/components/menu.vue'
import CompBall from '@/app/components/transferBall.vue'
import CompVersion from '@/app/components/versionAlert.vue'
import CompNew from '@/app/components/new.vue'
import CompAlive from '@/app/components/alive.vue'
import CompLang from '@/components/chooseLang.vue'
import CompDown from '@/app/components/download.vue'
import CompDownMsg from '@/app/components/downloadMsg.vue'
import CompBox from '@/views/box/other/index.vue'
import CompSpace from '@/components/box/workSpaceList.vue'
import CompMsg from '@/components/other/msg.vue'
import CompWorkspace from '@/components/box/workSpaceTop.vue'
// import CompFloating from '@/app/views/floating.vue'
import CompAnimation from '@/components/box/animation.vue'
// import CompBall from '@/components/client/ball.vue'
// import CompKeep from '@/components/client/keepAlive.vue'
// import CompEmail from '@/components/addEmail.vue'
import { mapGetters } from 'vuex'
import http from '@/http'
import router from '@/router'
export default {
  beforeRouteEnter (to, from, next) {
    if (http.prototype.constructor.defaults.headers['x-us-token'] !== localStorage.getItem('token')) {
      http.prototype.constructor.defaults.headers['x-us-token'] = localStorage.getItem('token')
    }
    http.get('/cydex/api/v1/projects', { params: {
      type: 3
    } })
      .then(response => {
        if (response.data.projects) {
          next()
        } else {
          router.push({ path: '/app/initial' })
        }
      })
  },
  computed: {
    ...mapGetters({
      space: 'space',
      show: 'show'
    }),
    'paddingLeft': function () {
      var left = ['110px', '300px']
      var data = this.show.left ? 1 : 0
      return left[data]
    }
  },
  data () {
    return {
      workSpaceLoaderStatus: false,
      browser: this._global.config.browser,
    }
  },
  watch: {
    'space': function () {
      if (this.$route.path === '/app/workspace/inbox') {
        this.$router.push({ path: './inbox' })
      }
      if (this.$route.path === '/app/workspace/outbox') {
        this.$router.push({ path: './outbox' })
      }
      if (this.$route.path === '/app/retrieve') {
        this.$router.push({ path: './retrieve' })
      }
    }
  },
  components: {
    CompBox,
    CompBar,
    CompMenu,
    CompBall,
    CompNew,
    CompVersion,
    CompAlive,
    CompLang,
    CompDown,
    CompSpace,
    CompKeep,
    CompKick,
    CompMsg,
    CompWorkspace,
    // CompFloating,
    CompAnimation,
    CompDownMsg,
  },
  mounted () {
    this.$api.getUser(response => {
      this.$store.dispatch('addUser', response)
    })
  },
  methods: {
    workSpaceLoader () {
      this.workSpaceLoaderStatus = true
    }
  }
}
</script>

<style lang="css" scoped>
.index-main {
  position: relative;
  background-color: #fff;
  height: 100%;
}
.main-box {
  z-index: 2;
  padding-top: 60px;
  position: relative;
  display: flex;
  min-height: 100%;
  background-color: #fff;
}
.view-box {
  order: 1;
  flex-grow: 1;
  width: auto;
  max-width: 1680px;
  min-height: 100%;
  margin: 0 auto;
  overflow: hidden;
  padding: 0 110px 0 110px;
  padding-left: calc(100vw - 100%);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.32s ease;
 }
.fade-enter, .fade-leave-to {
  opacity: 0;
}
@media (max-width: 1280px) {
  .view-box {
    padding: 0 50px 0 110px;
  }
}
@media (min-width: 1280px) {
  /* .view-box {
    padding: 0 200px 0 200px !important;
  } */
}
</style>
